import { createNamespacer, createReducer } from "../../commons/js/utils/reducer";

const initialState = {
    selectedFilter: {value: "", label: "Filter By Software"},
    searchKey: "",
    integrationsData: [],
    isLoading: false,
    isSuggestionsLoading: false,
    searchHeatNumber: "",
    suggestionsList: [],
    softwaresList: [],
    projectsList: [],
    selectedProject: {value: "", label: "Filter By Project"},
    selectedAccAlert: [],
    accFoldersList: [],
};

const integrations = createNamespacer("INTEGRATIONS");

const integrationsReducer = createReducer(initialState, {
    [integrations("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [integrations("SET_SELECTED_FILTER")]:(state, action) => {
        return {
            ...state,
            selectedFilter: action.payload.value
        }
    },
    [integrations("SET_SEARCH_STRING")] : (state, action) => {
        return {
            ...state,
            searchKey: action.payload.value
        }
    },
    [integrations("SET_INTEGRATIONS_DATA")] : (state, action) => {
        return {
            ...state,
            integrationsData: action.payload.value
        }
    },
    [integrations("SET_SUGGESTIONS_LOADING")]:(state, action) => {
        return {
            ...state,
            isSuggestionsLoading: action.payload.value,
        }
    },
    [integrations("SET_SEARCH_HEAT_NUMBERS")] : (state, action) => {
        return {
            ...state,
            searchHeatNumber: action.payload.value
        }
    },
    [integrations("SET_HEAT_NUMBERS_DATA")] : (state, action) => {
        return {
            ...state,
            suggestionsList: action.payload.value
        }
    },
    [integrations("SET_EXTERNAL_LIST")]:(state, action) => {
        return {
            ...state,
            softwaresList: action.payload.value
        }
    },
    [integrations("SET_PROJECTS_LIST")]:(state, action) => {
        return {
            ...state,
            projectsList: action.payload.value
        }
    },
    [integrations("SET_SELECTED_PROJECT")]:(state, action) => {
        return {
            ...state,
            selectedProject: action.payload.value
        }
    },
    [integrations("SET_ACC_ALERTS")]: (state, action) => {
        return {
            ...state,
            selectedAccAlert: action.payload.value,
        };
    },
    [integrations("SET_ACC_FOLDERS_LIST")]: (state, action) => {
        return {
            ...state,
            accFoldersList: action.payload.value,
        };
    },
});

export default integrationsReducer;